export default __webpack_public_path__ + "static/media/Medical.0d85c761.png";